import { z } from 'zod'
import { salesBusinessStatusSchema } from '../enums/sales-business-status.enum.js'

/** A business that receives payments (docs/sales.spec.md, "Stripe"): the company's, or a venue's own. */
export const salesBusinessDtoSchema = z.object({
  id: z.string().uuid(),
  /** Null: the company's, used by every venue without its own. */
  venueId: z.string().uuid().nullable(),
  status: salesBusinessStatusSchema,
  chargesEnabled: z.boolean(),
  payoutsEnabled: z.boolean(),
})
export type SalesBusinessDto = z.infer<typeof salesBusinessDtoSchema>

/** The company's business and each venue's, for the company's Getting paid page. */
export const salesBusinessesDtoSchema = z.object({
  company: salesBusinessDtoSchema.nullable(),
  venues: z.array(z.object({ venueId: z.string().uuid(), venueName: z.string(), business: salesBusinessDtoSchema.nullable() })),
  /** Whether payments can be set up in this deployment at all. */
  available: z.boolean(),
})
export type SalesBusinessesDto = z.infer<typeof salesBusinessesDtoSchema>

/** Who a venue's payments go to, for the venue's settings. */
export const venueSalesBusinessDtoSchema = z.object({
  /** `venue`: its own business; `company`: the company's; `none`: nobody yet. */
  paidBy: z.enum(['venue', 'company', 'none']),
  business: salesBusinessDtoSchema.nullable(),
  /** Whether this person can set up or finish the venue's own business. */
  canSetUpOwn: z.boolean(),
  available: z.boolean(),
})
export type VenueSalesBusinessDto = z.infer<typeof venueSalesBusinessDtoSchema>

/** What Stripe's components in the browser start from. */
export const salesBusinessSessionDtoSchema = z.object({
  clientSecret: z.string(),
  publishableKey: z.string(),
})
export type SalesBusinessSessionDto = z.infer<typeof salesBusinessSessionDtoSchema>
